/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { ApplicationDetailPageService } from '../index';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { RENEW_WORK_PERMIT } from '../../api/graphql';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};
export interface IRenewWorkPermitMethods extends IPluginMethodMap {
  renewWorkPermit(args: any): Promise<any>;
}

export interface RenewWorkPermitProps {}

export class RenewWorkPermitService implements IAgentPlugin {
  readonly methods: IRenewWorkPermitMethods;

  constructor() {
    this.methods = {
      renewWorkPermit: this.renewWorkPermit.bind(this),
    };
  }

  private async renewWorkPermit(args: any) {
    const srv = getSrv();

    console.log(`workPermitApp service input data`, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`workPermitApp service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      console.log(`workPermitApp service client`, client);
      if (client) {
        console.log('argssss23', args);
        const res = await client.mutation(RENEW_WORK_PERMIT, {
          ...args,
        });
        if (res?.data?.renewWorkPermit) {
          return res?.data?.renewWorkPermit;
        }
      } else {
        console.log('error in renew work permit');
      }
    } catch (err: any) {
      console.log('error in renew work permit', err?.message);
      throw err;
    }
  }
}
